import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs';
import { map } from 'rxjs/operators';

import { userLanguageChanged } from '../../../shared/store/actions/user-env';

@Injectable()
export class LangEffects {
    storeUserLanguage$ = createEffect(() =>
        this.translateService.onLangChange.pipe(
            map(({ lang }) => lang),
            startWith(this.translateService.getCurrentLang()),
            map((language) => userLanguageChanged({ language })),
        ),
    );

    constructor(private translateService: TranslateService) {}
}
